<!-- Content Wrapper Start -->
<div class="fm-content-wrapper fm-lovedone-page">
    <div class="container-fluid">

        @if (hasError()) {
            <div class="row mt-4">
                <div class="col-12">
                    <div class="fm-white-column text-center py-5">
                        <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
                        <p class="mb-3">We couldn't load the prompt details. Please try again.</p>
                        <button type="button" class="fm-common-btn mx-auto" (click)="loadDetail()">Try Again</button>
                    </div>
                </div>
            </div>
        } @else if (detail()) {
            <div class="row">

                <!-- Header -->
                <div class="col-12">
                    <app-back-button
                      backLink="/app/scheduleprompt"
                      [title]="detail()!.promptTitle || 'Scheduled Prompts'"
                      [categoryName]="
                        detail()!.categoryName || 'Automate memory collection with gentle reminders'
                      "
                    />
                </div>

                <!-- KPIs -->
                <div class="col-12 mt-4 mt-sm-3">
                    <div class="fm-cards-group">
                        <div class="row g-3">
                            <div class="col-sm-6 col-lg-3">
                                <div class="fm-white-column fm-card-icon fm-metric-card">
                                    <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">{{ detail()!.stats.totalReceived }}</h3>
                                        <p class="fm-large mb-0">Total Received</p>
                                    </div>
                                    <div class="fm-metric-icon">
                                        <img src="images/icons/fm-send.svg" class="fm-svg" alt="Total Received" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <div class="fm-white-column fm-card-icon fm-metric-card">
                                    <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">{{ detail()!.stats.responded }}</h3>
                                        <p class="fm-large mb-0">Responded</p>
                                    </div>
                                    <div class="fm-metric-icon">
                                        <img src="images/icons/fm-check-lg.svg" class="fm-svg" alt="Responded" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <div class="fm-white-column fm-card-icon fm-metric-card">
                                    <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">{{ detail()!.stats.pending }}</h3>
                                        <p class="fm-large mb-0">Pending</p>
                                    </div>
                                    <div class="fm-metric-icon">
                                        <img src="images/icons/fm-pending.svg" class="fm-svg" alt="Pending" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 col-lg-3">
                                <div class="fm-white-column fm-card-icon fm-metric-card">
                                    <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">{{ detail()!.stats.storiesCreated }}</h3>
                                        <p class="fm-large mb-0">Stories Created</p>
                                    </div>
                                    <div class="fm-metric-icon">
                                        <img src="images/icons/fm-book-lg.svg" class="fm-svg" alt="Stories Created" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Prompt Configuration -->
                <div class="col-12 mt-4">
                    <div class="fm-border-column fm-card-st2">
                        <div class="fm-card-head">
                            <h3 class="fm-head-20 fm-card-title mb-0">PROMPT CONFIGURATION</h3>
                        </div>
                        <div class="fm-card-body">
                            <div class="row g-4 align-items-center">
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Frequency:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.frequencyTypeName || '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Questions Per Prompt:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.questionPerPrompt  != null ? detail()!.questionPerPrompt  + ' Questions' : '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Delivery Method:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.deliveryMethodTypeName || '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Started On:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.promptStartDate ? formatDate(detail()!.promptStartDate) : '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Sent By:</p>
                                    <div class="d-flex align-items-center gap-2 mt-1">
                                        @if (detail()!.senderProfilePhotoUrl) {
                                            <span class="fm-avatar">
                                                <img [src]="detail()!.senderProfilePhotoUrl" alt="{{ detail()!.senderName }}" />
                                            </span>
                                        } @else {
                                            <span class="fm-avatar fm-avatar-initials">{{ getInitials(detail()!.senderName) }}</span>
                                        }
                                        <div>
                                            <p class="fm-large fw-semibold mb-0">{{ detail()!.senderName || '—' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Prompt History -->
                <div class="col-12 mt-4">
                    <div class="fm-prompt-history-sec fm-border-column fm-card-st2">
                        <div class="fm-card-head d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <h3 class="fm-head-20 fm-card-title mb-0">Prompt History</h3>
                            <ul class="fm-history-filter mb-0">
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'all'" (click)="setFilter('all'); $event.stopPropagation()">All</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'responded'" (click)="setFilter('responded'); $event.stopPropagation()">Responded</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'waiting'" (click)="setFilter('waiting'); $event.stopPropagation()">Awaiting Response</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'not-responded'" (click)="setFilter('not-responded'); $event.stopPropagation()">No Response Received</button></li>
                            </ul>
                        </div>
                        <div class="fm-card-body">
                            @if (filteredHistory().length === 0) {
                                <div class="text-center py-4">
                                    @if (activeFilter() === 'all') {
                                        <p class="mb-0 fm-large">No prompt history has been recorded yet.</p>
                                    } @else if (activeFilter() === 'responded') {
                                        <p class="mb-0 fm-large">You haven't responded to any prompts yet.</p>
                                    } @else if (activeFilter() === 'waiting') {
                                        <p class="mb-0 fm-large">There are no prompts currently awaiting a response.</p>
                                    } @else {
                                        <p class="mb-0 fm-large">No prompts without a response were found.</p>
                                    }
                                </div>
                            } @else {
                                <div class="accordion fm-accordion" id="fmInviteeHistoryAccordion">
                                    @for (item of filteredHistory(); track item.deliveryId; let i = $index) {
                                        <div class="fm-history-item" [ngClass]="getHistoryItemClass(item.responseStatus)" [attr.data-status]="item.responseStatus.toLowerCase()">
                                            <div class="fm-timeline-icon">
                                                <span class="fm-timeline-dot">
                                                    <i class="fm-timeline-icon-i bi" [ngClass]="getTimelineIcon(item.responseStatus)"></i>
                                                </span>
                                            </div>
                                            <div class="fm-history-box">
                                                <div class="accordion-item fm-accordion-item">
                                                    <h2 class="accordion-header fm-accordion-header">
                                                        <button class="accordion-button fm-accordion-button" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#inviteeHistory' + i" aria-expanded="true" [attr.aria-controls]="'inviteeHistory' + i">
                                                            <div class="fm-history-content">
                                                                <div class="fm-history-top">
                                                                    <div>
                                                                        <h3 class="fm-head-20 fm-history-prompt-name">Prompt #{{ item.promptNumber }}</h3>
                                                                        <p class="fm-history-send-date">Sent on {{ formatDate(item.deliveredDate) }}</p>
                                                                    </div>
                                                                    @if (item.responseStatus.toLowerCase() === 'responded') {
                                                                        <div class="fm-status-wrap">
                                                                            <span class="fm-status-badge fm-status-success">
                                                                                <i class="bi bi-check-circle-fill fm-badge-icon"></i>
                                                                                {{ getStatusLabel(item.responseStatus) }}
                                                                            </span>
                                                                            @if (item.responseDate) {
                                                                                <span class="fm-response-date">on {{ formatDate(item.responseDate) }}</span>
                                                                            }
                                                                        </div>
                                                                    } @else {
                                                                        <span class="fm-status-badge" [ngClass]="getStatusBadgeClass(item.responseStatus)">
                                                                            <i class="bi fm-badge-icon" [ngClass]="getTimelineIcon(item.responseStatus)"></i>
                                                                            {{ getStatusLabel(item.responseStatus) }}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </h2>
                                                    <div [id]="'inviteeHistory' + i" class="accordion-collapse collapse show">
                                                        <div class="accordion-body fm-accordion-body">
                                                            <div class="fm-question-list">
                                                                <label class="fm-question-label">Questions Sent:</label>
                                                                <ol class="fm-question-items">
                                                                    @for (q of item.questions; track $index) {
                                                                        <li class="fm-question-item">{{ q }}</li>
                                                                    }
                                                                </ol>
                                                            </div>
                                                            @if (item.responseStatus.toLowerCase() === 'responded') {
                                                                @if (item.storyId) {
                                                                    <div class="fm-prompt-footer mt-2">
                                                                        <a [routerLink]="['/app/stories', item.storyId]" class="fm-view-story-btn">
                                                                            View Story <i class="bi bi-arrow-right"></i>
                                                                        </a>
                                                                    </div>
                                                                }
                                                            } @else if (item.responseStatus.toLowerCase() === 'awaitingresponse') {
                                                                <div class="fm-prompt-footer mt-3">
                                                                    <a [routerLink]="['/app/scheduleprompt/record', item.deliveryId]" class="fm-record-response-btn fm-common-btn" style="text-decoration: none;">
                                                                        <i class="bi bi-mic-fill"></i> Record a Response
                                                                    </a>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div>
        } @else {
            <div class="row mt-4">
                <div class="col-12">
                    <div class="fm-white-column text-center py-5">
                        <h4 class="fm-head-24 fm-head-sty2">No data available</h4>
                        <p class="mb-3">We couldn't find details for this prompt. It may have been removed or you may not have access.</p>
                        <a routerLink="/app/scheduleprompt" class="fm-common-btn">Back to Scheduled Prompts</a>
                    </div>
                </div>
            </div>
        }

    </div>
</div>
<!-- Content Wrapper End -->